export default __webpack_public_path__ + "3d415eb426cb668caac59fe9d3fcc961.png";